import { FC } from 'react';

import { motion } from 'framer-motion';

import { useLoadingCallback } from '@ui-furniture/hooks/use-loading-callback';
import { x } from '@ui-furniture/style';
import { LoadingButton } from '@ui-furniture/ui/loading/button';

export const ButtonChatInput: FC<{
  config: {
    label: string;
    submit: () => Promise<boolean>;
  };
  onAnswer: () => void;
}> = ({ onAnswer, config: { label, submit } }) => {
  const [isLoading, action] = useLoadingCallback(async () => {
    const wasSuccessful = await submit();
    if (wasSuccessful) onAnswer();
  }, [submit, onAnswer]);
  return (
    <motion.div layout style={{ overflow: 'hidden', padding: '1px' }}>
      <x.div mb='sm'>
        <LoadingButton
          type='submit'
          isLoading={isLoading}
          onClick={action}
          w='100%'
        >
          {label}
        </LoadingButton>
      </x.div>
    </motion.div>
  );
};
